import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../generic/crud";
import {ENTITY_ID_WORKER} from "../generic/Constants";
import {defaultWorker} from "../generic/InitialStates";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AGCText} from "../../generic-components/AGCText";
import {AGCTextArea} from "../../generic-components/AGCTextArea";


export function WorkerAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [forUpdate, setForUpdate] = useState(false);
    const [objectForSubmit, setObjectForSubmit] = useState(defaultWorker);
    const [isLoading, setIsLoading] = useState(false);
    const [title, setTitle] = useState("Worker");
    const entityName = "Worker";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        onSubmit(worker, {resetForm}) {
            setIsLoading(true);
            if (!id) {
                apiGenericCreate(ENTITY_ID_WORKER, worker).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_WORKER, worker, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(false);

            genericGetOne(ENTITY_ID_WORKER, id).then(
                ({data}) => {
                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultWorker);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Worker Name"}
                                         placeHolder={'Enter Worker Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Worker Name"}
                                         value={formik.values.name}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Phone"}
                                         placeHolder={'Enter Phone Number'}
                                         id={"phone"}
                                         toolTip={"Please enter the Phone Number"}
                                         value={formik.values.phone}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-12">
                                <AGCTextArea formik={formik}
                                         name={"Address"}
                                         placeHolder={'Enter Address'}
                                         id={"address"}
                                         toolTip={"Please enter the Address"}
                                         value={formik.values.address}
                                         rows={3}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"PAN"}
                                         placeHolder={'Enter PAN Number'}
                                         id={"pan"}
                                         toolTip={"Please enter the PAN Number"}
                                         value={formik.values.pan}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Aadhar"}
                                         placeHolder={'Enter Aadhar Number'}
                                         id={"aadhar"}
                                         toolTip={"Please enter the Aadhar Number"}
                                         value={formik.values.aadhar}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row mt-6">
                            <Form.Group className="col-lg-12">
                                <Form.Check
                                    type="checkbox"
                                    id="userActive"
                                    label="Active"
                                    checked={formik.values.userActive}
                                    onChange={formik.handleChange}
                                />
                                <Form.Text className="text-muted">
                                    If unchecked, this worker will be marked as inactive (no longer working with us)
                                    and will not appear in attendance screens or other worker lists.
                                </Form.Text>
                            </Form.Group>
                        </div>

                        <div className="separator separator-dashed my-6"></div>

                        <h5 className="mb-5">Bank Details</h5>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Bank Account Holder Name"}
                                         placeHolder={'Enter Bank Account Holder Name'}
                                         id={"bankAccountUserName"}
                                         toolTip={"Please enter the Bank Account Holder Name"}
                                         value={formik.values.bankAccountUserName}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Bank Account Number"}
                                         placeHolder={'Enter Bank Account Number'}
                                         id={"bankAccountNumber"}
                                         toolTip={"Please enter the Bank Account Number"}
                                         value={formik.values.bankAccountNumber}/>
                            </Form.Group>
                        </div>

                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"IFSC Code"}
                                         placeHolder={'Enter IFSC Code'}
                                         id={"ifscCode"}
                                         toolTip={"Please enter the IFSC Code"}
                                         value={formik.values.ifscCode}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Bank Branch"}
                                         placeHolder={'Enter Bank Branch'}
                                         id={"bankBranch"}
                                         toolTip={"Please enter the Bank Branch"}
                                         value={formik.values.bankBranch}/>
                            </Form.Group>
                        </div>

                        <br/>
                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
